import type { SiteControllerSettingAirHostFormModel } from "@/components/features/settings/site-controller/model/air-host/type";
import type { SiteControllerSettingAirHostFormModelMethodsType } from "@/components/features/settings/site-controller/model/air-host/use-case/use-create-model/methods";

import { SettingsSiteControllerAirHostAPIAccessToken } from "./air-host-api-access-token";
import { SettingsSiteControllerAirHostPartnerID } from "./air-host-partner-id";
import { SettingsSiteControllerAirHostPropertyID } from "./air-host-property-id";

type Props = {
	airHostViewModel: SiteControllerSettingAirHostFormModel["ViewModel"];
	siteControllerSettingAirHostFormModelMethods: SiteControllerSettingAirHostFormModelMethodsType;
};

export const SettingsSiteControllerAirHostMainSection = ({
	airHostViewModel,
	siteControllerSettingAirHostFormModelMethods: {
		onSetAirHostAPIAccessToken,
		onSetAirHostPartnerID,
		onSetAirHostPropertyID,
	},
}: Props) => {
	return (
		<div className="space-y-12">
			<div className="font-semibold underline underline-offset-4">
				<p>
					パートナーID・アクセストークンの取得方法は、ページ上部の「AirHostと連携する方法」をご確認ください。
				</p>
			</div>
			<SettingsSiteControllerAirHostPartnerID
				airHostPartnerID={airHostViewModel.airHostSettings.airHostPartnerID}
				onSetAirHostPartnerID={onSetAirHostPartnerID}
			/>
			<SettingsSiteControllerAirHostAPIAccessToken
				airHostAPIAccessToken={airHostViewModel.airHostSettings.airHostAPIAccessToken}
				onSetAirHostAPIAccessToken={onSetAirHostAPIAccessToken}
			/>
			<SettingsSiteControllerAirHostPropertyID
				airHostPropertyID={airHostViewModel.airHostSettings.airHostPropertyID}
				onSetAirHostPropertyID={onSetAirHostPropertyID}
			/>
		</div>
	);
};

SettingsSiteControllerAirHostMainSection.displayName = "SettingsSiteControllerAirHostMainSection";
